var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"full-width",attrs:{"headers":[
    { text: 'MES ID', value: 'tactId' },
    { text: 'Start', value: 'startTime' },
    { text: 'End', value: 'finishTime' },
    { text: 'ANT', value: 'in_ant' },
  ],"items":_vm.mesTacts},scopedSlots:_vm._u([{key:"item.startTime",fn:function({ item }){return [_vm._v(" "+_vm._s(_vm.getDateTimeFromTimestamp(item.startTime))+" ")]}},{key:"item.finishTime",fn:function({ item }){return [_vm._v(" "+_vm._s(_vm.getDateTimeFromTimestamp(item.finishTime))+" ")]}},{key:"item.in_ant",fn:function({ item }){return [_c('v-simple-checkbox',{attrs:{"disabled":!_vm.loggedInAnt(item),"value":_vm.loggedInAnt(item)},on:{"click":function($event){return _vm.addTactToAnt(item)}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }